// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".side-content[data-v-c83aa8b0]{border-right:1px solid #eee}.top[data-v-c83aa8b0]{margin-top:10px;margin-bottom:3px}", ""]);
// Exports
module.exports = exports;
